"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SnackbarProvider = exports.mapDispatchToProps = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _array = require("lodash/array");

var _util = require("lodash/util");

var _actions = require("./actions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    snackbar: (0, _util.defaultTo)((0, _array.head)(state.snackbar.queue), null)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dismiss: function dismiss(id) {
      return dispatch((0, _actions.dismiss)(id));
    }
  };
};

exports.mapDispatchToProps = mapDispatchToProps;

var SnackbarProvider =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SnackbarProvider, _React$PureComponent);

  function SnackbarProvider() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SnackbarProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SnackbarProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      open: false,
      message: '',
      action: ''
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClose", function () {
      _this.setState({
        open: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onExited", function () {
      _this.processQueue();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onActionClick", function () {
      _this.onClose();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "processQueue", function () {
      if (_this.props.snackbar) {
        var _this$props$snackbar = _this.props.snackbar,
            message = _this$props$snackbar.message,
            action = _this$props$snackbar.action;

        _this.setState({
          open: true,
          message: message,
          action: action
        });

        _this.props.dismiss(_this.props.snackbar.id);
      }
    });

    return _this;
  }

  _createClass(SnackbarProvider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.snackbar !== prevProps.snackbar) {
        if (this.props.snackbar) {
          this.state.open ? this.setState({
            open: false
          }) : this.processQueue();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          _this$props$SnackbarP = _this$props.SnackbarProps,
          SnackbarProps = _this$props$SnackbarP === void 0 ? {} : _this$props$SnackbarP;
      var _this$state = this.state,
          action = _this$state.action,
          message = _this$state.message,
          open = _this$state.open;
      return React.createElement(React.Fragment, null, children, React.createElement(_Snackbar.default, _extends({}, SnackbarProps, {
        action: action && React.createElement(_Button.default, {
          color: "secondary",
          size: "small",
          onClick: this.onActionClick
        }, action),
        message: (0, _util.defaultTo)(message, ''),
        onClose: this.onClose,
        onExited: this.onExited,
        open: open
      })));
    }
  }]);

  return SnackbarProvider;
}(React.PureComponent);

exports.SnackbarProvider = SnackbarProvider;

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SnackbarProvider);

exports.default = _default;